module.exports = __webpack_public_path__ + "img/icon-save.f2443f9c.svg";